import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { PostPopupMode } from './modals/WriterPopup/types';
import LoadablePostPopup from './modals/PostPopup';
import LoadableWriterPopup from './modals/WriterPopup/LoadableWriterPopup';

export const submitModalRenderer = (modalType: string, requestClose: () => void, params?: any) => {
  switch (modalType) {
    case ModalType.STATUS_UPDATE:
      return <LoadablePostPopup onClose={requestClose} {...params} mode={PostPopupMode.STATUS} />;

    case ModalType.JOURNAL:
      return <LoadablePostPopup onClose={requestClose} {...params} mode={PostPopupMode.JOURNAL} />;

    case ModalType.LITERATURE:
      return <LoadableWriterPopup onClose={requestClose} {...params} type="LITERATURE" />;

    default:
      return null;
  }
};
